<template>
  <div class="fixed inset-0 z-50 overflow-y-auto">
    <!-- Backdrop -->
    <div 
      class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm transition-opacity" 
      @click="$emit('cancel')"
    ></div>

    <!-- Modal Container -->
    <div class="fixed inset-0 z-50 overflow-y-auto">
      <div class="flex min-h-screen items-center justify-center p-4">
        <div class="relative transform bg-white rounded-lg shadow-xl max-w-md w-full transition-all duration-300 scale-100 opacity-100">
          <!-- Modal content -->
          <div class="p-6">
            <h3 class="text-xl font-semibold text-gray-900 mb-3">
              {{ title }}
            </h3>
            <p class="text-gray-600">
              {{ message }}
            </p>
          </div>

          <!-- Modal actions -->
          <div class="bg-gray-50 px-6 py-4 rounded-b-lg flex justify-end gap-3">
            <button
              @click="$emit('cancel')"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg transition-colors"
            >
              Cancel
            </button>
            <button
              @click="$emit('confirm')"
              class="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 shadow-sm rounded-lg transition-colors"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Confirm Action'
    },
    message: {
      type: String,
      required: true
    }
  },
  emits: ['confirm', 'cancel']
}
</script>
